module.exports = __webpack_public_path__ + "media/styles/images/svg/person-check-orange-56ae08f359a3fc82746dc67459187f23.svg";